module.exports = __webpack_public_path__ + "images/temporary/email-chart.svg";